<template>
	<div
		class="w-full max-w-140 group-[.received]:me-auto group-[.received]:pe-15 group-[.sent]:ms-auto group-[.sent]:ps-15"
	>
		<div
			class="rounded-xl p-3 w-full border group-[.received]:rounded-tl-none group-[.received]:bg-white group-[.received]:border-gray-darker group-[.received]:text-primary-superdark group-[.sent]:rounded-br-none group-[.sent]:bg-primary group-[.sent]:border-primary group-[.sent]:text-white"
		>
			<div>
				<em> Zpráva byla smazána </em>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { Props } from '@/types/Message'
const props = defineProps<Props>()
</script>

<style scoped></style>
